import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input, Button, Label } from "reactstrap";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import AmazonProductListingMainPage from "./AmazonProductListingMainPage"; 
import fetchAsinOptimizationSummaryService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchAsinOptimizationSummaryService";
import fetchAmazonListingStoreListService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchAmazonListingStoreListService";
import CustomModal from "../../../Components/Modals/CustomModal";

function AmazonProductListingStore(props) {

  const [storeList, setStoreList] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [selectedAsin, setSelectedAsin] = useState("");
  const [summaryData, setSummaryData] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [selectedSku, setSelectedSku] = useState("");
  const [showSkuModal, setShowSkuModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [tempSelectedSku, setTempSelectedSku] = useState("");
  console.log(selectedStoreDetails)
  useEffect(() => {
    fetchAmazonListingStoreListService(props.token).then((res) => {
      if (res && res.storeList) {
        setStoreList(res.storeList);
      }
    });
  }, [props.token]);

  const handleStoreChange = async (e) => {
    const storeId = Number(e.target.value);
    setSelectedStore(storeId);
    setSummaryData([]);
    setSearchText("");

    const store = storeList.find((s) => s.id === storeId);
    setSelectedStoreDetails(store || null);
    if (store && store.integerID) {
      setLoadingSummary(true);
      const data ={
        integerID:store.integerID
      }
      const res = await fetchAsinOptimizationSummaryService(props.token, data);
      if (res && res.summaryList) {
        console.log(res)
        setSummaryData(res.summaryList);
      }
      setLoadingSummary(false);
    }
  };

  const filteredSummaryData = summaryData.filter((row) => {
    const text = searchText.toLowerCase();
    return (
      (row.Asin || "").toLowerCase().includes(text) ||
      String(row.IntegerId || "").includes(text) ||String(row.productTitle || "").toLowerCase().includes(text) || String(row.Sku || "").toLowerCase().includes(text)|| 
      String(row.isParentProduct ? "yes" : "no").toLowerCase().includes(text)
    );
  });

  
  const handleAsinClick = (product) => {
    if (!selectedStoreDetails) return;
  
    setSelectedProduct(product);
    setSelectedAsin(product.Asin);
  
    const skuList = product && product.skus
      ? product.skus
          .split(",")
          .map((sku) => sku.trim())
          .filter((sku) => sku)
      : [];
  
    // Zero SKU
    if (skuList.length === 0) {
      setTempSelectedSku("");
      setShowSkuModal(true);
    }
  
    // Single SKU → direct redirect
    if (skuList.length === 1) {
      setSelectedSku(skuList[0]);
      return;
    }
  
    // Multiple SKU → open modal
    setTempSelectedSku(skuList[0]);
    setShowSkuModal(true);
  };



  const columns = [
    {
      Header: "Integer ID",
      accessor: "IntegerId",
      width: 180,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value}</p>
        </div>
      ),
    },
    {
        Header: "ASIN",
        accessor: "Asin",
        width: 150,
        Cell: (cellInfo) => {
          return (
            <div className="d-flex justify-content-center w-100">
              <p
                className='mb-0'
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "blue",
                  // fontWeight: isSelected ? "bold" : "normal"
                }}
                onClick={() => handleAsinClick(cellInfo.row._original)}
              >
                {cellInfo.value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "SKU",
        accessor: "Sku",
        width: 250,
        Cell: ({ value }) => (
          <div className="d-flex justify-content-center w-100">
            <p className="mb-0">
              {value || "-"}
            </p>
          </div>
        ),
      },
      {
        Header: "IsParent",
        accessor: "isParentProduct",
        width: 100,
        Cell: ({ value }) => (
          <div className="d-flex justify-content-center w-100">
            <p className='mb-0'>{value ? "Yes" : "No"}</p>
          </div>
        ),
      },
    {
        Header: "Product Title",
        accessor: "productTitle",
        width: 450,
        Cell: ({ value }) => (
          <div className="d-flex justify-content-start w-100">
            <p className="mb-0">{value}</p>
          </div>
        ),
      },
    {
      Header: "Fields",
      accessor: "Fields",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Mandatory",
      accessor: "MandatoryFieldCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Basic",
      accessor: "BasicFieldCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Missing",
      accessor: "MissingFieldCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">
            {value?value:"-"}
          </p>
        </div>
      ),
    },
    // {
    //   Header: "Errors",
    //   accessor: "ErrorsFieldCounts",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">
    //       {value?value:"-"}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   Header: "Warnings",
    //   accessor: "WarningFieldCounts",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">
    //       {value?value:"-"}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      Header: "Total",
      accessor: "TotalFieldsCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Valid",
      accessor: "ValidFieldsCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">
          {value?value:"-"}
          </p>
        </div>
      ),
    },
  ];

  if (selectedSku) {
    return (
      <AmazonProductListingMainPage 
        asin={selectedAsin} 
        sku={selectedSku}
        storeDetails={selectedStoreDetails} 
        // onBack={() => setSelectedAsin("")}
        onBack={() => setSelectedSku("")}
        setSummaryData={setSummaryData}
      />
    );
  }
  return (
    <>
      <Container>
        <Row className="mt-5">

          <Col md={12} className="mt-2 mb-2 mt-5">
            <h4>Amazon Listing : Store Selection </h4>
          </Col>

          <Col md={12} className="ml-1 mr-4">
            <Card className="p-4">

              <Row className="mb-3 align-items-center">
              <Col md={6}>
                  <Row className="align-items-center">
                    <Col md={3} className="amazon-listing-labels mb-0">
                      Store :
                    </Col>
                  <Col md={9}>
                  <Input
                    type="select"
                    value={selectedStore}
                    onChange={handleStoreChange}
                  >
                    <option value="">-- Select Store --</option>
                    {storeList && storeList.map((store) => (
                      <option key={store.id} value={store.id}>
                        {store.name}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              </Col>
              <Col md={6}>
                  {selectedStoreDetails && (
                    <div className="d-flex justify-content-end">
                      <Input
                        className="w-100" 
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        placeholder="Search Product....."
                      />
                    </div>
                  )}
                </Col>

              </Row>

              {selectedStoreDetails && (
              <>
                {/* <Row className="mt-4 mb-2">
                  <Col md={4}>
                    <p className="mb-0"><b>Seller ID</b></p>
                    <p>{selectedStoreDetails.stringID}</p>
                  </Col>
                  <Col md={4}>
                    <p className="mb-0"><b>Marketplace ID</b></p>
                    <p>{selectedStoreDetails.marketplaceStringId}</p>
                  </Col>
                  <Col md={4}>
                    <p className="mb-0"><b>Currency</b></p>
                    <p>{selectedStoreDetails.currencyCode}</p>
                  </Col>
                </Row> */}

                <Row>

                  <Col md={12}>
                    <ReactTable
                      data={filteredSummaryData}
                      columns={columns}
                      loading={loadingSummary}
                      className="-fixed -highlight -striped mt-2"
                      getTheadProps={() => ({
                        style: {
                          overflowY: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                      defaultPageSize={10}
                      noDataText={loadingSummary ? "Loading Data..." : "No Data Found."}
                    />
                  </Col>
                </Row>
              </>)}

            </Card>
          </Col>
<CustomModal
    header={"Select SKU"}
    isOpen={showSkuModal}
    toggle={() => setShowSkuModal(!showSkuModal)}
    className='curve-popup'
    footer={(
      <>
          <Button
                // color="link"
                className="mr-3"
                onClick={() => {
                    setShowSkuModal(false);
                    setSelectedSku("");
                }}
            >
                Cancel
            </Button>
            <Button
                className="btn btn-success"
                disabled={!selectedProduct || !selectedProduct.skus}
                onClick={() => {

                  setSelectedSku(tempSelectedSku);

                    setShowSkuModal(false);
                }}
            >
                Submit
            </Button>
      </>
  )}

    
>
<Row>
  <Col md={12}>
    <div className="mt-2 mb-2">
    {selectedProduct && selectedProduct.skus ? (
      <>
        <Input
            type="select"
            defaultValue={
              selectedProduct && selectedProduct.skus
                  ? selectedProduct.skus.split(",")[0].trim()
                  : ""
          }
            onChange={(e) =>
              setTempSelectedSku(e.target.value)
            }
        >

            {(selectedProduct && selectedProduct.skus
                  ? selectedProduct.skus.split(",")
                  : []
              ).map((sku, index) => (
                <option
                    key={index}
                    value={sku.trim()}
                >
                    {sku.trim()}
                </option>
            ))}

        </Input>
        </>
           ) : (
            <div className="text-center text-danger mt-3">
              <p>
                SKU not available for this ASIN.
                </p>
            </div>
        )}

    </div>
    </Col>
            </Row>

  </CustomModal>


        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(AmazonProductListingStore);